import React from "react";
import { Icon } from "../Icon";

const BASE = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  fontFamily: "var(--kr-font-sans)",
  fontWeight: 600,
  borderRadius: 6,
  border: "1px solid transparent",
  whiteSpace: "nowrap",
  transition:
    "background var(--kr-dur-fast) var(--kr-ease-out), color var(--kr-dur-fast) var(--kr-ease-out), box-shadow var(--kr-dur-fast) var(--kr-ease-out), border-color var(--kr-dur-fast) var(--kr-ease-out), transform var(--kr-dur-press) var(--kr-ease-out)",
  textDecoration: "none",
};

const SIZES = {
  sm: { height: 28, padding: "0 10px", fontSize: 12 },
  md: { height: 32, padding: "0 14px", fontSize: 13 },
  lg: { height: 40, padding: "0 18px", fontSize: 14 },
};

const VARIANTS = {
  primary: {
    background: "var(--kr-action)",
    color: "var(--kr-action-fg)",
  },
  secondary: {
    background: "var(--kr-bg-surface)",
    color: "var(--kr-fg-strong)",
    borderColor: "var(--kr-border)",
  },
  ghost: {
    background: "transparent",
    color: "var(--kr-fg-strong)",
  },
  soft: {
    background: "var(--kr-action-soft-bg)",
    color: "var(--kr-action-soft-fg)",
  },
  danger: {
    background: "var(--kr-danger-500)",
    color: "#fff",
  },
  dangerSoft: {
    background: "var(--kr-bg-surface)",
    borderColor: "var(--kr-danger-100)",
    color: "var(--kr-danger-700)",
  },
};

const ICON_SIZE = { sm: 12, md: 14, lg: 16 };

export function Button({
  variant = "primary",
  size = "md",
  icon,
  iconRight,
  children,
  onClick,
  disabled,
  type = "button",
  title,
  style,
  className,
  fullWidth = false,
  form,
}) {
  const dis = disabled
    ? {
        background: "var(--kr-neutral-100)",
        color: "var(--kr-neutral-500)",
        borderColor: "var(--kr-border)",
        cursor: "not-allowed",
      }
    : { cursor: "pointer" };
  const cls = ["kr-btn", className].filter(Boolean).join(" ");
  return (
    <button
      type={type}
      form={form}
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={cls}
      style={{
        ...BASE,
        ...SIZES[size],
        ...VARIANTS[variant],
        ...dis,
        width: fullWidth ? "100%" : undefined,
        ...(style || {}),
      }}
    >
      {icon && <Icon name={icon} size={ICON_SIZE[size]} />}
      {children}
      {iconRight && <Icon name={iconRight} size={ICON_SIZE[size]} />}
    </button>
  );
}

if (typeof document !== "undefined" && !document.getElementById("kr-btn-keyframes")) {
  const s = document.createElement("style");
  s.id = "kr-btn-keyframes";
  s.textContent = `.kr-btn:active:not(:disabled) { transform: scale(0.97); }`;
  document.head.appendChild(s);
}

export default Button;
